import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserAccessStore } from '../services/user-access/user-access.store';
import { RegisteredApplicationStore } from '../services/registered-applications/registered-application.store';

export const adminAreaGuard: CanActivateFn = () => {
  const store = inject(UserAccessStore);
  const reg = inject(RegisteredApplicationStore);
  const router = inject(Router);

  return store.load().pipe(
    map((access) => {
      store.reconcilePreferredEntryWithAccess(access);

      if (!access.isAdmin) {
        if (!access.isDeveloper && !access.isSupport) {
          return router.parseUrl('/no-access');
        }
        if (access.isDeveloper) {
          return router.parseUrl('/projects');
        }
        return router.parseUrl('/registered-applications');
      }

      store.setPreferredEntry('admin');
      reg.clear();
      return true;
    }),
    catchError(() => of(router.parseUrl('/no-access')))
  );
};
